import { render, staticRenderFns } from "./_modal_duplicate.vue?vue&type=template&id=35d0932a"
import script from "./_modal_duplicate.vue?vue&type=script&lang=js"
export * from "./_modal_duplicate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports